module.exports = __webpack_public_path__ + "img/ua.3697c943.svg";